import { originatesFromRemoteBackendAgent, type Transaction } from '@canvas/transaction';

interface GetBackendAgentEditedFieldIdsOptions {
  changedFieldIds: readonly string[];
  currentFieldIds: readonly string[];
  previousFieldIds: readonly string[];
  transaction: Transaction;
}

export function getBackendAgentEditedFieldIds({
  changedFieldIds,
  currentFieldIds,
  previousFieldIds,
  transaction
}: GetBackendAgentEditedFieldIdsOptions): readonly string[] {
  if (!originatesFromRemoteBackendAgent(transaction)) {
    return [];
  }

  const currentFieldIdSet = new Set(currentFieldIds);
  const previousFieldIdSet = new Set(previousFieldIds);
  return [...new Set(changedFieldIds)].filter(
    (fieldId) => currentFieldIdSet.has(fieldId) && previousFieldIdSet.has(fieldId)
  );
}
